import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-400 py-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 items-center gap-4">
          <p className="text-sm text-left">© {new Date().getFullYear()} VidCreator Studio. All rights reserved.</p>
          <p className="text-sm text-right">info@sceneextractor.com</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
